import { useSelector } from "react-redux";
import { InfoIcon } from "staysure-component-library";

import { ANNUAL_MULTI_TRIP } from "@/constants";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { BenefitCopyDataType } from "@/schema/quote-page/page.schema";
import { CoverBenefitsType } from "@/schema/renewal-page/middle-panel.schema";
import { RootState } from "@/store/root-reducer";
import { DynamicCoverLimitProduct } from "@/types/DynamicCoverLimitProductType";

import Styles from "./benefits-list.module.css";
import { CancellationCoverModalProps, Item } from "./item";

type BenefitsListProps = {
  benefitsCopies?: CoverBenefitsType;
  currentPolicy: string;
  cancellationModalData: CancellationCoverModalProps;
  isUKRegionFromLocation: boolean | "" | undefined;
  isUKRegionToLocationsOnly: boolean;
};

export function BenefitsList({
  benefitsCopies,
  currentPolicy,
  isUKRegionFromLocation,
  cancellationModalData,
}: Readonly<BenefitsListProps>) {
  const [isdesktop, isReady] = useMediaQuery("(min-width: 904px)");
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { tripDetails } = attributes;

  const checkDividerVisible = (index: number): boolean => {
    if (!benefitsCopies?.length) return false;
    if (isdesktop) {
      return (
        index === benefitsCopies.length - 1 ||
        index === benefitsCopies.length - 2
      );
    }
    return index === benefitsCopies.length - 1;
  };

  const dynamicCoverLimit =
    attributes?.priceResult?.dynamicCoverLimit?.[0]?.product?.find(
      (coverPackage: DynamicCoverLimitProduct) =>
        coverPackage.policyType === ANNUAL_MULTI_TRIP &&
        coverPackage.policyPackage === currentPolicy
    );

  const firstBenefit = benefitsCopies?.[0];

  const isExcluded = (data: BenefitCopyDataType) => {
    if (
      data.isMedicalExpenses &&
      isUKRegionFromLocation &&
      tripDetails?.area === "UK" &&
      tripDetails?.policyType === ANNUAL_MULTI_TRIP
    ) {
      return false;
    }
    return data.isActive;
  };

  if (!isReady) return null;

  return (
    <>
      {firstBenefit ? (
        <Item
          key="benefit-0"
          benefitsCopy={firstBenefit}
          currentPolicy={currentPolicy}
          modalData={cancellationModalData}
          dynamicCoverLimit={dynamicCoverLimit ?? null}
          id="benefit-0"
          icon={
            <div
              className={`${Styles.icon} ${currentPolicy.toLocaleLowerCase()}`}
            >
              <InfoIcon stroke="#fff" />
            </div>
          }
          className="justify-center"
          dividerClassName="lg:!my-spacing-m"
        />
      ) : null}

      <div
        className="grid grid-cols-1 lg:grid-cols-2  lg:gap-x-spacing-l"
        id="benefits-list"
      >
        {benefitsCopies?.map((benefit, index) =>
          index !== 0 && isExcluded(benefit) ? (
            <Item
              key={`benefit-${index + 1}`}
              id={`benefit-${index}`}
              benefitsCopy={benefit}
              modalData={cancellationModalData}
              currentPolicy={currentPolicy}
              dynamicCoverLimit={dynamicCoverLimit ?? null}
              isHideDivider={checkDividerVisible(index)}
            />
          ) : null
        )}
      </div>
    </>
  );
}
